import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

function Simulado() {
  const navigate = useNavigate();
  const { materia } = useParams();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [mensagem, setMensagem] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }
    setQuestions([]);
    setMensagem("");
    setShowResult(false);
    setScore(0);
    setCurrent(0);
    setLoading(true);
    async function fetchQuestions() {
      const res = await fetch(`/api/questions?materia=${encodeURIComponent(materia)}` , {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setQuestions(data);
        if (data.length === 0) {
          setMensagem("Não há questões cadastradas para esta matéria.");
        }
      } else {
        setMensagem("Erro ao carregar questões. Faça login novamente.");
      }
      setLoading(false);
    }
    fetchQuestions();
  }, [token, navigate, materia]);

  const handleSelect = (qid, idx) => {
    setAnswers({ ...answers, [qid]: idx });
  };

  const handlePrev = () => {
    setCurrent((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrent((prev) => Math.min(prev + 1, questions.length - 1));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let acertos = 0;
    questions.forEach(q => {
      if (answers[q.id] === q.correta - 1) acertos++;
    });
    setScore(acertos);
    setShowResult(true);
    fetch("/api/results", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ score: acertos }),
    }).then(res => {
      if (!res.ok) setMensagem("Erro ao enviar resultado.");
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleEncerrar = () => {
    navigate("/");
  };

  const percent = questions.length ? Math.round((score / questions.length) * 100) : 0;
  const isAprovado = percent >= 70;

  return (
    <div style={{
      position: "relative",
      minHeight: "100vh",
      width: "100vw",
      overflow: "hidden"
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 0,
        background: `url(/cockpit.jpg) center center / cover no-repeat`
      }} />
      <div style={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100vw",
        background: "rgba(255,255,255,0.5)"
      }}>
        <div style={{width: "100%", maxWidth: "500px"}}>
          {loading ? (
            <div style={{textAlign: "center", padding: "2em"}}>
              <h2>Carregando questões...</h2>
            </div>
          ) : showResult ? (
            <div style={{width: "100%", maxWidth: "400px"}}>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1em"}}>
                <h2 style={{margin: 0}}>Resultado do Simulado</h2>
                <button onClick={handleLogout} style={{padding: "0.5em 1em", background: "#c00", color: "#fff", border: "none", borderRadius: "4px"}}>Sair</button>
              </div>
              <div style={{background: isAprovado ? "#d4edda" : "#f8d7da", color: isAprovado ? "#155724" : "#721c24", borderRadius: "12px", boxShadow: "0 2px 12px #0002", padding: "2.5em 2em", textAlign: "center", marginBottom: "2em"}}>
                <div style={{fontSize: "3em", marginBottom: "0.5em"}}>
                  {isAprovado ? "✅" : "❌"}
                </div>
                <strong style={{fontSize: "1.5em", display: "block", marginBottom: "0.5em"}}>
                  {isAprovado ? "Parabéns! Você foi aprovado!" : "Você não atingiu a nota mínima."}
                </strong>
                <div style={{fontSize: "1.2em", marginBottom: "0.5em"}}>
                  Pontuação: <span style={{fontWeight: "bold"}}>{score}</span> de <span style={{fontWeight: "bold"}}>{questions.length}</span> <br />
                  <span style={{fontWeight: "bold"}}>{percent}%</span> de acertos
                </div>
                <div style={{marginTop: "1.5em"}}>
                  <button onClick={() => window.location.reload()} style={{padding: "0.7em 1.5em", background: isAprovado ? "#28a745" : "#dc3545", color: "#fff", border: "none", borderRadius: "6px", fontSize: "1em", cursor: "pointer"}}>
                    Refazer Simulado
                  </button>
                    {/* Botão removido para evitar duplicidade e garantir rotação */}
                </div>
              </div>
              {/* Revisão das questões */}
              <div style={{background: "#fff", borderRadius: "8px", boxShadow: "0 2px 8px #0002", padding: "1.5em", marginBottom: "2em"}}>
                <h3 style={{marginTop: 0}}>Revisão das Questões</h3>
                <ul style={{listStyle: "none", padding: 0}}>
                  {questions.map((q, idx) => {
                    const marcada = answers[q.id];
                    const correta = q.correta;
                    const acertou = marcada === correta - 1;
                    return (
                      <li key={q.id} style={{marginBottom: "1.2em", borderBottom: "1px solid #eee", paddingBottom: "1em"}}>
                        <div style={{fontWeight: "bold"}}>{idx + 1}. {q.enunciado}</div>
                        <div>
                          Sua resposta: <span style={{color: acertou ? "#28a745" : "#dc3545", fontWeight: "bold"}}>
                            {typeof marcada === "number" ? q.alternativas[marcada] : <em>Não respondida</em>}
                          </span>
                        </div>
                        <div>
                          Correta: <span style={{fontWeight: "bold"}}>{q.alternativas[correta - 1]}</span>
                        </div>
                        <div>
                          {acertou ? <span style={{color: "#28a745"}}>✔ Acertou</span> : <span style={{color: "#dc3545"}}>✖ Errou</span>}
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          ) : (
            <>
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1em"}}>
                <h2>Simulado - {materia}</h2>
                <div style={{display: 'flex', gap: 12}}>
                  <button onClick={handleEncerrar} style={{padding: "0.5em 1em", background: "#1976d2", color: "#fff", border: "none", borderRadius: "4px"}}>Encerrar Simulado</button>
                  <button onClick={handleLogout} style={{padding: "0.5em 1em", background: "#c00", color: "#fff", border: "none", borderRadius: "4px"}}>Sair</button>
                </div>
              </div>
              {mensagem && <p>{mensagem}</p>}
              {questions.length > 0 ? (
                <form onSubmit={handleSubmit}>
                  <div style={{background: "#fff", borderRadius: "8px", boxShadow: "0 2px 8px #0002", padding: "2em", textAlign: "center"}}>
                    <strong style={{fontSize: "1.2em"}}>{questions[current].enunciado}</strong>
                    <div style={{marginTop: "1em"}}>
                      {questions[current].alternativas.map((alt, idx) => (
                        <label key={idx} style={{display: "block", margin: "0.5em 0"}}>
                          <input
                            type="radio"
                            name={`q_${questions[current].id}`}
                            checked={answers[questions[current].id] === idx}
                            onChange={() => handleSelect(questions[current].id, idx)}
                          />
                          {alt}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div style={{display: "flex", justifyContent: "space-between", marginTop: "2em"}}>
                    <button type="button" onClick={handlePrev} disabled={current === 0} style={{padding: "0.5em 1em"}}>Voltar</button>
                    {current < questions.length - 1 ? (
                      <button type="button" onClick={handleNext} style={{padding: "0.5em 1em"}}>Avançar</button>
                    ) : (
                      <button type="submit" style={{padding: "0.5em 1em", background: "#007bff", color: "#fff", border: "none", borderRadius: "4px"}}>Enviar Simulado</button>
                    )}
                  </div>
                  <div style={{marginTop: "1em", textAlign: "right", color: "#555"}}>
                    Questão {current + 1} de {questions.length}
                  </div>
                </form>
              ) : (
                <div style={{textAlign: "center", padding: "2em", color: "#c00", fontWeight: "bold"}}>
                  Não há questões disponíveis para esta matéria ou ocorreu um erro ao carregar as questões.
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Simulado;
